/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.
import { Injectable } from "@angular/core";
import { Client, generateClient, GraphQLResult } from "aws-amplify/api";
import { Observable } from "rxjs";

export type __SubscriptionContainer = {
  onCreateCardSettings: OnCreateCardSettingsSubscription;
  onCreateTrackingUsers: OnCreateTrackingUsersSubscription;
  onUpdateCardSettings: OnUpdateCardSettingsSubscription;
  onUpdateTrackingUsers: OnUpdateTrackingUsersSubscription;
};

export type CreateCardSettingsInput = {
  account: number;
  segmentRef?: string | null;
  showSpecialOffer?: boolean | null;
};

export type CardSettings = {
  __typename: "CardSettings";
  account: number;
  segmentRef?: string | null;
  showSpecialOffer?: boolean | null;
};

export type CreateTrackingUsersInput = {
  cardNumber?: number | null;
  fidelity?: string | null;
  finalDate?: number | null;
  initialDate?: number | null;
  lastStepReached?: string | null;
  paymentAmount?: number | null;
  paymentMethod?: string | null;
  promotionCash?: number | null;
  promotionCashBonus?: number | null;
  promotionTickets?: number | null;
  promotionTokenBonus?: number | null;
  promotionTokens?: number | null;
  registeredEmail?: string | null;
  uid: string;
};

export type TrackingUsers = {
  __typename: "TrackingUsers";
  cardNumber?: number | null;
  fidelity?: string | null;
  finalDate?: number | null;
  initialDate?: number | null;
  lastStepReached?: string | null;
  paymentAmount?: number | null;
  paymentMethod?: string | null;
  promotionCash?: number | null;
  promotionCashBonus?: number | null;
  promotionTickets?: number | null;
  promotionTokenBonus?: number | null;
  promotionTokens?: number | null;
  registeredEmail?: string | null;
  uid: string;
};

export type UpdateCardSettingsInput = {
  account: number;
  segmentRef?: string | null;
  showSpecialOffer?: boolean | null;
};

export type UpdateTrackingUsersInput = {
  cardNumber?: number | null;
  fidelity?: string | null;
  finalDate?: number | null;
  initialDate?: number | null;
  lastStepReached?: string | null;
  paymentAmount?: number | null;
  paymentMethod?: string | null;
  promotionCash?: number | null;
  promotionCashBonus?: number | null;
  promotionTickets?: number | null;
  promotionTokenBonus?: number | null;
  promotionTokens?: number | null;
  registeredEmail?: string | null;
  uid: string;
};

export type Promotions = {
  __typename: "Promotions";
  amount?: number | null;
  basesDescription?: string | null;
  bonusAmount?: number | null;
  bonusToken?: number | null;
  color?: string | null;
  daysAvailable?: Array<string | null> | null;
  durationDescription?: string | null;
  enabled?: boolean | null;
  finalDate?: string | null;
  initialDate?: string | null;
  isDeleted?: boolean | null;
  isEnabledAllCustomers?: boolean | null;
  isSegmentedOffer?: boolean | null;
  name?: string | null;
  paymentAmount?: number | null;
  relatedPromotionUid?: string | null;
  segment_uid?: string | null;
  tickets?: number | null;
  token?: number | null;
  typeOfAdminPromotion?: string | null;
  typeOfPromotion?: string | null;
  uid: string;
  updateTime?: string | null;
};

export type Repurchase = {
  __typename: "Repurchase";
  created_at?: string | null;
  isLatest?: boolean | null;
  paymentImageURL?: string | null;
  promotion_snapshot?: string | null;
  repurchase_amount?: number | null;
  uid: string;
  updated_at?: string | null;
  waiverImageURL?: string | null;
};

export type Segments = {
  __typename: "Segments";
  creationDate?: string | null;
  isDeleted?: boolean | null;
  lastUpdate?: string | null;
  name?: string | null;
  offerRepeatLimit?: string | null;
  offerShowTiming?: string | null;
  offerType?: string | null;
  onlyNewCards?: boolean | null;
  paymentImageURL?: string | null;
  promotionRef?: string | null;
  redirectToPromotion?: boolean | null;
  status?: boolean | null;
  uid: string;
  waiverImageURL?: string | null;
};

export type WebClientSettings = {
  __typename: "WebClientSettings";
  environment?: string | null;
  maxAccountTimeLimit?: number | null;
  minAccountTimeLimit?: number | null;
  uid: string;
};

export type TableCardSettingsFilterInput = {
  account?: TableIntFilterInput | null;
  segmentRef?: TableStringFilterInput | null;
  showSpecialOffer?: TableBooleanFilterInput | null;
};

export type TableIntFilterInput = {
  between?: Array<number | null> | null;
  contains?: number | null;
  eq?: number | null;
  ge?: number | null;
  gt?: number | null;
  le?: number | null;
  lt?: number | null;
  ne?: number | null;
  notContains?: number | null;
};

export type TableStringFilterInput = {
  beginsWith?: string | null;
  between?: Array<string | null> | null;
  contains?: string | null;
  eq?: string | null;
  ge?: string | null;
  gt?: string | null;
  le?: string | null;
  lt?: string | null;
  ne?: string | null;
  notContains?: string | null;
};

export type TableBooleanFilterInput = {
  eq?: boolean | null;
  ne?: boolean | null;
};

export type CardSettingsConnection = {
  __typename: "CardSettingsConnection";
  items?: Array<CardSettings | null> | null;
  nextToken?: string | null;
};

export type TablePromotionsFilterInput = {
  amount?: TableIntFilterInput | null;
  basesDescription?: TableStringFilterInput | null;
  bonusAmount?: TableIntFilterInput | null;
  bonusToken?: TableIntFilterInput | null;
  color?: TableStringFilterInput | null;
  daysAvailable?: TableStringFilterInput | null;
  durationDescription?: TableStringFilterInput | null;
  enabled?: TableBooleanFilterInput | null;
  finalDate?: TableStringFilterInput | null;
  initialDate?: TableStringFilterInput | null;
  isDeleted?: TableBooleanFilterInput | null;
  isEnabledAllCustomers?: TableBooleanFilterInput | null;
  name?: TableStringFilterInput | null;
  paymentAmount?: TableIntFilterInput | null;
  relatedPromotionUid?: TableIDFilterInput | null;
  segment_uid?: TableStringFilterInput | null;
  tickets?: TableIntFilterInput | null;
  token?: TableIntFilterInput | null;
  typeOfAdminPromotion?: TableStringFilterInput | null;
  typeOfPromotion?: TableStringFilterInput | null;
  uid?: TableIDFilterInput | null;
  updateTime?: TableStringFilterInput | null;
};

export type TableIDFilterInput = {
  beginsWith?: string | null;
  between?: Array<string | null> | null;
  contains?: string | null;
  eq?: string | null;
  ge?: string | null;
  gt?: string | null;
  le?: string | null;
  lt?: string | null;
  ne?: string | null;
  notContains?: string | null;
};

export type PromotionsConnection = {
  __typename: "PromotionsConnection";
  items?: Array<Promotions | null> | null;
  nextToken?: string | null;
};

export type TableRepurchaseFilterInput = {
  created_at?: TableStringFilterInput | null;
  isLatest?: TableBooleanFilterInput | null;
  paymentImageURL?: TableStringFilterInput | null;
  repurchase_amount?: TableIntFilterInput | null;
  uid?: TableStringFilterInput | null;
  updated_at?: TableStringFilterInput | null;
  waiverImageURL?: TableStringFilterInput | null;
};

export type RepurchaseConnection = {
  __typename: "RepurchaseConnection";
  items?: Array<Repurchase | null> | null;
  nextToken?: string | null;
};

export type TableSegmentsFilterInput = {
  creationDate?: TableStringFilterInput | null;
  isDeleted?: TableBooleanFilterInput | null;
  lastUpdate?: TableStringFilterInput | null;
  name?: TableStringFilterInput | null;
  offerRepeatLimit?: TableStringFilterInput | null;
  offerShowTiming?: TableStringFilterInput | null;
  offerType?: TableStringFilterInput | null;
  onlyNewCards?: TableBooleanFilterInput | null;
  paymentImageURL?: TableStringFilterInput | null;
  promotionRef?: TableStringFilterInput | null;
  redirectToPromotion?: TableBooleanFilterInput | null;
  status?: TableBooleanFilterInput | null;
  uid?: TableStringFilterInput | null;
  waiverImageURL?: TableStringFilterInput | null;
};

export type SegmentsConnection = {
  __typename: "SegmentsConnection";
  items?: Array<Segments | null> | null;
  nextToken?: string | null;
};

export type TableTrackingUsersFilterInput = {
  cardNumber?: TableFloatFilterInput | null;
  fidelity?: TableStringFilterInput | null;
  finalDate?: TableFloatFilterInput | null;
  initialDate?: TableFloatFilterInput | null;
  lastStepReached?: TableStringFilterInput | null;
  paymentAmount?: TableFloatFilterInput | null;
  paymentMethod?: TableStringFilterInput | null;
  promotionCash?: TableFloatFilterInput | null;
  promotionCashBonus?: TableFloatFilterInput | null;
  promotionTickets?: TableFloatFilterInput | null;
  promotionTokenBonus?: TableFloatFilterInput | null;
  promotionTokens?: TableFloatFilterInput | null;
  registeredEmail?: TableStringFilterInput | null;
  uid?: TableStringFilterInput | null;
};

export type TableFloatFilterInput = {
  between?: Array<number | null> | null;
  contains?: number | null;
  eq?: number | null;
  ge?: number | null;
  gt?: number | null;
  le?: number | null;
  lt?: number | null;
  ne?: number | null;
  notContains?: number | null;
};

export type TrackingUsersConnection = {
  __typename: "TrackingUsersConnection";
  items?: Array<TrackingUsers | null> | null;
  nextToken?: string | null;
};

export type TableWebClientSettingsFilterInput = {
  environment?: TableStringFilterInput | null;
  maxAccountTimeLimit?: TableIntFilterInput | null;
  minAccountTimeLimit?: TableIntFilterInput | null;
  uid?: TableStringFilterInput | null;
};

export type WebClientSettingsConnection = {
  __typename: "WebClientSettingsConnection";
  items?: Array<WebClientSettings | null> | null;
  nextToken?: string | null;
};

export type CreateCardSettingsMutation = {
  __typename: "CardSettings";
  account: number;
  segmentRef?: string | null;
  showSpecialOffer?: boolean | null;
};

export type CreateTrackingUsersMutation = {
  __typename: "TrackingUsers";
  cardNumber?: number | null;
  fidelity?: string | null;
  finalDate?: number | null;
  initialDate?: number | null;
  lastStepReached?: string | null;
  paymentAmount?: number | null;
  paymentMethod?: string | null;
  promotionCash?: number | null;
  promotionCashBonus?: number | null;
  promotionTickets?: number | null;
  promotionTokenBonus?: number | null;
  promotionTokens?: number | null;
  registeredEmail?: string | null;
  uid: string;
};

export type UpdateCardSettingsMutation = {
  __typename: "CardSettings";
  account: number;
  segmentRef?: string | null;
  showSpecialOffer?: boolean | null;
};

export type UpdateTrackingUsersMutation = {
  __typename: "TrackingUsers";
  cardNumber?: number | null;
  fidelity?: string | null;
  finalDate?: number | null;
  initialDate?: number | null;
  lastStepReached?: string | null;
  paymentAmount?: number | null;
  paymentMethod?: string | null;
  promotionCash?: number | null;
  promotionCashBonus?: number | null;
  promotionTickets?: number | null;
  promotionTokenBonus?: number | null;
  promotionTokens?: number | null;
  registeredEmail?: string | null;
  uid: string;
};

export type GetCardSettingsQuery = {
  __typename: "CardSettings";
  account: number;
  segmentRef?: string | null;
  showSpecialOffer?: boolean | null;
};

export type GetPromotionsQuery = {
  __typename: "Promotions";
  amount?: number | null;
  basesDescription?: string | null;
  bonusAmount?: number | null;
  bonusToken?: number | null;
  color?: string | null;
  daysAvailable?: Array<string | null> | null;
  durationDescription?: string | null;
  enabled?: boolean | null;
  finalDate?: string | null;
  initialDate?: string | null;
  isDeleted?: boolean | null;
  isEnabledAllCustomers?: boolean | null;
  isSegmentedOffer?: boolean | null;
  name?: string | null;
  paymentAmount?: number | null;
  relatedPromotionUid?: string | null;
  segment_uid?: string | null;
  tickets?: number | null;
  token?: number | null;
  typeOfAdminPromotion?: string | null;
  typeOfPromotion?: string | null;
  uid: string;
  updateTime?: string | null;
};

export type GetRepurchaseQuery = {
  __typename: "Repurchase";
  created_at?: string | null;
  isLatest?: boolean | null;
  paymentImageURL?: string | null;
  promotion_snapshot?: string | null;
  repurchase_amount?: number | null;
  uid: string;
  updated_at?: string | null;
  waiverImageURL?: string | null;
};

export type GetSegmentsQuery = {
  __typename: "Segments";
  creationDate?: string | null;
  isDeleted?: boolean | null;
  lastUpdate?: string | null;
  name?: string | null;
  offerRepeatLimit?: string | null;
  offerShowTiming?: string | null;
  offerType?: string | null;
  onlyNewCards?: boolean | null;
  paymentImageURL?: string | null;
  promotionRef?: string | null;
  redirectToPromotion?: boolean | null;
  status?: boolean | null;
  uid: string;
  waiverImageURL?: string | null;
};

export type GetTrackingUsersQuery = {
  __typename: "TrackingUsers";
  cardNumber?: number | null;
  fidelity?: string | null;
  finalDate?: number | null;
  initialDate?: number | null;
  lastStepReached?: string | null;
  paymentAmount?: number | null;
  paymentMethod?: string | null;
  promotionCash?: number | null;
  promotionCashBonus?: number | null;
  promotionTickets?: number | null;
  promotionTokenBonus?: number | null;
  promotionTokens?: number | null;
  registeredEmail?: string | null;
  uid: string;
};

export type GetWebClientSettingsQuery = {
  __typename: "WebClientSettings";
  environment?: string | null;
  maxAccountTimeLimit?: number | null;
  minAccountTimeLimit?: number | null;
  uid: string;
};

export type ListCardSettingsQuery = {
  __typename: "CardSettingsConnection";
  items?: Array<{
    __typename: "CardSettings";
    account: number;
    segmentRef?: string | null;
    showSpecialOffer?: boolean | null;
  } | null> | null;
  nextToken?: string | null;
};

export type ListPromotionsQuery = {
  __typename: "PromotionsConnection";
  items?: Array<{
    __typename: "Promotions";
    amount?: number | null;
    basesDescription?: string | null;
    bonusAmount?: number | null;
    bonusToken?: number | null;
    color?: string | null;
    daysAvailable?: Array<string | null> | null;
    durationDescription?: string | null;
    enabled?: boolean | null;
    finalDate?: string | null;
    initialDate?: string | null;
    isDeleted?: boolean | null;
    isEnabledAllCustomers?: boolean | null;
    isSegmentedOffer?: boolean | null;
    name?: string | null;
    paymentAmount?: number | null;
    relatedPromotionUid?: string | null;
    segment_uid?: string | null;
    tickets?: number | null;
    token?: number | null;
    typeOfAdminPromotion?: string | null;
    typeOfPromotion?: string | null;
    uid: string;
    updateTime?: string | null;
  } | null> | null;
  nextToken?: string | null;
};

export type ListRepurchasesQuery = {
  __typename: "RepurchaseConnection";
  items?: Array<{
    __typename: "Repurchase";
    created_at?: string | null;
    isLatest?: boolean | null;
    paymentImageURL?: string | null;
    promotion_snapshot?: string | null;
    repurchase_amount?: number | null;
    uid: string;
    updated_at?: string | null;
    waiverImageURL?: string | null;
  } | null> | null;
  nextToken?: string | null;
};

export type ListSegmentsQuery = {
  __typename: "SegmentsConnection";
  items?: Array<{
    __typename: "Segments";
    creationDate?: string | null;
    isDeleted?: boolean | null;
    lastUpdate?: string | null;
    name?: string | null;
    offerRepeatLimit?: string | null;
    offerShowTiming?: string | null;
    offerType?: string | null;
    onlyNewCards?: boolean | null;
    paymentImageURL?: string | null;
    promotionRef?: string | null;
    redirectToPromotion?: boolean | null;
    status?: boolean | null;
    uid: string;
    waiverImageURL?: string | null;
  } | null> | null;
  nextToken?: string | null;
};

export type ListTrackingUsersQuery = {
  __typename: "TrackingUsersConnection";
  items?: Array<{
    __typename: "TrackingUsers";
    cardNumber?: number | null;
    fidelity?: string | null;
    finalDate?: number | null;
    initialDate?: number | null;
    lastStepReached?: string | null;
    paymentAmount?: number | null;
    paymentMethod?: string | null;
    promotionCash?: number | null;
    promotionCashBonus?: number | null;
    promotionTickets?: number | null;
    promotionTokenBonus?: number | null;
    promotionTokens?: number | null;
    registeredEmail?: string | null;
    uid: string;
  } | null> | null;
  nextToken?: string | null;
};

export type ListWebClientSettingsQuery = {
  __typename: "WebClientSettingsConnection";
  items?: Array<{
    __typename: "WebClientSettings";
    environment?: string | null;
    maxAccountTimeLimit?: number | null;
    minAccountTimeLimit?: number | null;
    uid: string;
  } | null> | null;
  nextToken?: string | null;
};

export type OnCreateCardSettingsSubscription = {
  __typename: "CardSettings";
  account: number;
  segmentRef?: string | null;
  showSpecialOffer?: boolean | null;
};

export type OnCreateTrackingUsersSubscription = {
  __typename: "TrackingUsers";
  cardNumber?: number | null;
  fidelity?: string | null;
  finalDate?: number | null;
  initialDate?: number | null;
  lastStepReached?: string | null;
  paymentAmount?: number | null;
  paymentMethod?: string | null;
  promotionCash?: number | null;
  promotionCashBonus?: number | null;
  promotionTickets?: number | null;
  promotionTokenBonus?: number | null;
  promotionTokens?: number | null;
  registeredEmail?: string | null;
  uid: string;
};

export type OnUpdateCardSettingsSubscription = {
  __typename: "CardSettings";
  account: number;
  segmentRef?: string | null;
  showSpecialOffer?: boolean | null;
};

export type OnUpdateTrackingUsersSubscription = {
  __typename: "TrackingUsers";
  cardNumber?: number | null;
  fidelity?: string | null;
  finalDate?: number | null;
  initialDate?: number | null;
  lastStepReached?: string | null;
  paymentAmount?: number | null;
  paymentMethod?: string | null;
  promotionCash?: number | null;
  promotionCashBonus?: number | null;
  promotionTickets?: number | null;
  promotionTokenBonus?: number | null;
  promotionTokens?: number | null;
  registeredEmail?: string | null;
  uid: string;
};

@Injectable({
  providedIn: "root"
})
export class APIService {
  public client: Client;
  constructor() {
    this.client = generateClient();
  }
  async CreateCardSettings(
    input: CreateCardSettingsInput
  ): Promise<CreateCardSettingsMutation> {
    const statement = `mutation CreateCardSettings($input: CreateCardSettingsInput!) {
        createCardSettings(input: $input) {
          __typename
          account
          segmentRef
          showSpecialOffer
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <CreateCardSettingsMutation>response.data.createCardSettings;
  }
  async CreateTrackingUsers(
    input: CreateTrackingUsersInput
  ): Promise<CreateTrackingUsersMutation> {
    const statement = `mutation CreateTrackingUsers($input: CreateTrackingUsersInput!) {
        createTrackingUsers(input: $input) {
          __typename
          cardNumber
          fidelity
          finalDate
          initialDate
          lastStepReached
          paymentAmount
          paymentMethod
          promotionCash
          promotionCashBonus
          promotionTickets
          promotionTokenBonus
          promotionTokens
          registeredEmail
          uid
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <CreateTrackingUsersMutation>response.data.createTrackingUsers;
  }
  async UpdateCardSettings(
    input: UpdateCardSettingsInput
  ): Promise<UpdateCardSettingsMutation> {
    const statement = `mutation UpdateCardSettings($input: UpdateCardSettingsInput!) {
        updateCardSettings(input: $input) {
          __typename
          account
          segmentRef
          showSpecialOffer
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UpdateCardSettingsMutation>response.data.updateCardSettings;
  }
  async UpdateTrackingUsers(
    input: UpdateTrackingUsersInput
  ): Promise<UpdateTrackingUsersMutation> {
    const statement = `mutation UpdateTrackingUsers($input: UpdateTrackingUsersInput!) {
        updateTrackingUsers(input: $input) {
          __typename
          cardNumber
          fidelity
          finalDate
          initialDate
          lastStepReached
          paymentAmount
          paymentMethod
          promotionCash
          promotionCashBonus
          promotionTickets
          promotionTokenBonus
          promotionTokens
          registeredEmail
          uid
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UpdateTrackingUsersMutation>response.data.updateTrackingUsers;
  }
  async GetCardSettings(account: number): Promise<GetCardSettingsQuery> {
    const statement = `query GetCardSettings($account: Float!) {
        getCardSettings(account: $account) {
          __typename
          account
          segmentRef
          showSpecialOffer
        }
      }`;
    const gqlAPIServiceArguments: any = {
      account
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <GetCardSettingsQuery>response.data.getCardSettings;
  }
  async GetPromotions(uid: string): Promise<GetPromotionsQuery> {
    const statement = `query GetPromotions($uid: ID!) {
        getPromotions(uid: $uid) {
          __typename
          amount
          basesDescription
          bonusAmount
          bonusToken
          color
          daysAvailable
          durationDescription
          enabled
          finalDate
          initialDate
          isDeleted
          isEnabledAllCustomers
          isSegmentedOffer
          name
          paymentAmount
          relatedPromotionUid
          segment_uid
          tickets
          token
          typeOfAdminPromotion
          typeOfPromotion
          uid
          updateTime
        }
      }`;
    const gqlAPIServiceArguments: any = {
      uid
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <GetPromotionsQuery>response.data.getPromotions;
  }
  async GetRepurchase(uid: string): Promise<GetRepurchaseQuery> {
    const statement = `query GetRepurchase($uid: String!) {
        getRepurchase(uid: $uid) {
          __typename
          created_at
          isLatest
          paymentImageURL
          promotion_snapshot
          repurchase_amount
          uid
          updated_at
          waiverImageURL
        }
      }`;
    const gqlAPIServiceArguments: any = {
      uid
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <GetRepurchaseQuery>response.data.getRepurchase;
  }
  async GetSegments(uid: string): Promise<GetSegmentsQuery> {
    const statement = `query GetSegments($uid: String!) {
        getSegments(uid: $uid) {
          __typename
          creationDate
          isDeleted
          lastUpdate
          name
          offerRepeatLimit
          offerShowTiming
          offerType
          onlyNewCards
          paymentImageURL
          promotionRef
          redirectToPromotion
          status
          uid
          waiverImageURL
        }
      }`;
    const gqlAPIServiceArguments: any = {
      uid
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <GetSegmentsQuery>response.data.getSegments;
  }
  async GetTrackingUsers(uid: string): Promise<GetTrackingUsersQuery> {
    const statement = `query GetTrackingUsers($uid: String!) {
        getTrackingUsers(uid: $uid) {
          __typename
          cardNumber
          fidelity
          finalDate
          initialDate
          lastStepReached
          paymentAmount
          paymentMethod
          promotionCash
          promotionCashBonus
          promotionTickets
          promotionTokenBonus
          promotionTokens
          registeredEmail
          uid
        }
      }`;
    const gqlAPIServiceArguments: any = {
      uid
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <GetTrackingUsersQuery>response.data.getTrackingUsers;
  }
  async GetWebClientSettings(uid: string): Promise<GetWebClientSettingsQuery> {
    const statement = `query GetWebClientSettings($uid: String!) {
        getWebClientSettings(uid: $uid) {
          __typename
          environment
          maxAccountTimeLimit
          minAccountTimeLimit
          uid
        }
      }`;
    const gqlAPIServiceArguments: any = {
      uid
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <GetWebClientSettingsQuery>response.data.getWebClientSettings;
  }
  async ListCardSettings(
    filter?: TableCardSettingsFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListCardSettingsQuery> {
    const statement = `query ListCardSettings($filter: TableCardSettingsFilterInput, $limit: Int, $nextToken: String) {
        listCardSettings(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            account
            segmentRef
            showSpecialOffer
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <ListCardSettingsQuery>response.data.listCardSettings;
  }
  async ListPromotions(
    filter?: TablePromotionsFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListPromotionsQuery> {
    const statement = `query ListPromotions($filter: TablePromotionsFilterInput, $limit: Int, $nextToken: String) {
        listPromotions(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            amount
            basesDescription
            bonusAmount
            bonusToken
            color
            daysAvailable
            durationDescription
            enabled
            finalDate
            initialDate
            isDeleted
            isEnabledAllCustomers
            isSegmentedOffer
            name
            paymentAmount
            relatedPromotionUid
            segment_uid
            tickets
            token
            typeOfAdminPromotion
            typeOfPromotion
            uid
            updateTime
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <ListPromotionsQuery>response.data.listPromotions;
  }
  async ListRepurchases(
    filter?: TableRepurchaseFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListRepurchasesQuery> {
    const statement = `query ListRepurchases($filter: TableRepurchaseFilterInput, $limit: Int, $nextToken: String) {
        listRepurchases(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            created_at
            isLatest
            paymentImageURL
            promotion_snapshot
            repurchase_amount
            uid
            updated_at
            waiverImageURL
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <ListRepurchasesQuery>response.data.listRepurchases;
  }
  async ListSegments(
    filter?: TableSegmentsFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListSegmentsQuery> {
    const statement = `query ListSegments($filter: TableSegmentsFilterInput, $limit: Int, $nextToken: String) {
        listSegments(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            creationDate
            isDeleted
            lastUpdate
            name
            offerRepeatLimit
            offerShowTiming
            offerType
            onlyNewCards
            paymentImageURL
            promotionRef
            redirectToPromotion
            status
            uid
            waiverImageURL
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <ListSegmentsQuery>response.data.listSegments;
  }
  async ListTrackingUsers(
    filter?: TableTrackingUsersFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListTrackingUsersQuery> {
    const statement = `query ListTrackingUsers($filter: TableTrackingUsersFilterInput, $limit: Int, $nextToken: String) {
        listTrackingUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            cardNumber
            fidelity
            finalDate
            initialDate
            lastStepReached
            paymentAmount
            paymentMethod
            promotionCash
            promotionCashBonus
            promotionTickets
            promotionTokenBonus
            promotionTokens
            registeredEmail
            uid
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <ListTrackingUsersQuery>response.data.listTrackingUsers;
  }
  async ListWebClientSettings(
    filter?: TableWebClientSettingsFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListWebClientSettingsQuery> {
    const statement = `query ListWebClientSettings($filter: TableWebClientSettingsFilterInput, $limit: Int, $nextToken: String) {
        listWebClientSettings(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            environment
            maxAccountTimeLimit
            minAccountTimeLimit
            uid
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <ListWebClientSettingsQuery>response.data.listWebClientSettings;
  }
  OnCreateCardSettingsListener(
    account?: number,
    showSpecialOffer?: boolean
  ): Observable<
    GraphQLResult<Pick<__SubscriptionContainer, "onCreateCardSettings">>
  > {
    const statement = `subscription OnCreateCardSettings($account: Float, $showSpecialOffer: Boolean) {
        onCreateCardSettings(account: $account, showSpecialOffer: $showSpecialOffer) {
          __typename
          account
          segmentRef
          showSpecialOffer
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (account) {
      gqlAPIServiceArguments.account = account;
    }
    if (showSpecialOffer) {
      gqlAPIServiceArguments.showSpecialOffer = showSpecialOffer;
    }
    return this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    }) as any;
  }

  OnCreateTrackingUsersListener(
    cardNumber?: number,
    fidelity?: string,
    finalDate?: number,
    initialDate?: number,
    uid?: string
  ): Observable<
    GraphQLResult<Pick<__SubscriptionContainer, "onCreateTrackingUsers">>
  > {
    const statement = `subscription OnCreateTrackingUsers($cardNumber: Float, $fidelity: String, $finalDate: Float, $initialDate: Float, $uid: String) {
        onCreateTrackingUsers(
          cardNumber: $cardNumber
          fidelity: $fidelity
          finalDate: $finalDate
          initialDate: $initialDate
          uid: $uid
        ) {
          __typename
          cardNumber
          fidelity
          finalDate
          initialDate
          lastStepReached
          paymentAmount
          paymentMethod
          promotionCash
          promotionCashBonus
          promotionTickets
          promotionTokenBonus
          promotionTokens
          registeredEmail
          uid
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (cardNumber) {
      gqlAPIServiceArguments.cardNumber = cardNumber;
    }
    if (fidelity) {
      gqlAPIServiceArguments.fidelity = fidelity;
    }
    if (finalDate) {
      gqlAPIServiceArguments.finalDate = finalDate;
    }
    if (initialDate) {
      gqlAPIServiceArguments.initialDate = initialDate;
    }
    if (uid) {
      gqlAPIServiceArguments.uid = uid;
    }
    return this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    }) as any;
  }

  OnUpdateCardSettingsListener(
    account?: number,
    showSpecialOffer?: boolean
  ): Observable<
    GraphQLResult<Pick<__SubscriptionContainer, "onUpdateCardSettings">>
  > {
    const statement = `subscription OnUpdateCardSettings($account: Float, $showSpecialOffer: Boolean) {
        onUpdateCardSettings(account: $account, showSpecialOffer: $showSpecialOffer) {
          __typename
          account
          segmentRef
          showSpecialOffer
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (account) {
      gqlAPIServiceArguments.account = account;
    }
    if (showSpecialOffer) {
      gqlAPIServiceArguments.showSpecialOffer = showSpecialOffer;
    }
    return this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    }) as any;
  }

  OnUpdateTrackingUsersListener(
    cardNumber?: number,
    fidelity?: string,
    finalDate?: number,
    initialDate?: number,
    uid?: string
  ): Observable<
    GraphQLResult<Pick<__SubscriptionContainer, "onUpdateTrackingUsers">>
  > {
    const statement = `subscription OnUpdateTrackingUsers($cardNumber: Float, $fidelity: String, $finalDate: Float, $initialDate: Float, $uid: String) {
        onUpdateTrackingUsers(
          cardNumber: $cardNumber
          fidelity: $fidelity
          finalDate: $finalDate
          initialDate: $initialDate
          uid: $uid
        ) {
          __typename
          cardNumber
          fidelity
          finalDate
          initialDate
          lastStepReached
          paymentAmount
          paymentMethod
          promotionCash
          promotionCashBonus
          promotionTickets
          promotionTokenBonus
          promotionTokens
          registeredEmail
          uid
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (cardNumber) {
      gqlAPIServiceArguments.cardNumber = cardNumber;
    }
    if (fidelity) {
      gqlAPIServiceArguments.fidelity = fidelity;
    }
    if (finalDate) {
      gqlAPIServiceArguments.finalDate = finalDate;
    }
    if (initialDate) {
      gqlAPIServiceArguments.initialDate = initialDate;
    }
    if (uid) {
      gqlAPIServiceArguments.uid = uid;
    }
    return this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    }) as any;
  }
}
